export default "__VITE_ASSET__1EIlenoI__"